import { render, staticRenderFns } from "./addressItem.vue?vue&type=template&id=57f86f92&scoped=true"
import script from "./addressItem.vue?vue&type=script&lang=js"
export * from "./addressItem.vue?vue&type=script&lang=js"
import style0 from "./addressItem.vue?vue&type=style&index=0&id=57f86f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f86f92",
  null
  
)

export default component.exports